/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BoxGoodsDto
 */
export interface BoxGoodsDto {
    /**
     * 主键ID
     * @type {number}
     * @memberof BoxGoodsDto
     */
    id?: number;
    /**
     * 箱子ID
     * @type {number}
     * @memberof BoxGoodsDto
     */
    boxId?: number;
    /**
     * 商品ID
     * @type {number}
     * @memberof BoxGoodsDto
     */
    goodsId?: number;
    /**
     * SKU ID
     * @type {number}
     * @memberof BoxGoodsDto
     */
    skuId?: number;
    /**
     * 商品数量
     * @type {number}
     * @memberof BoxGoodsDto
     */
    quantity?: number;
    /**
     * 冻结商品数量
     * @type {number}
     * @memberof BoxGoodsDto
     */
    freezeQuantity?: number;
    /**
     * 可用商品数量
     * @type {number}
     * @memberof BoxGoodsDto
     */
    availableQuantity?: number;
    /**
     * 是否可用 0不可用 1可用
     * @type {number}
     * @memberof BoxGoodsDto
     */
    enable?: number;
    /**
     * 是否删除 0未删除 1已删除
     * @type {number}
     * @memberof BoxGoodsDto
     */
    deleteStatus?: number;
    /**
     * 订单ID
     * @type {number}
     * @memberof BoxGoodsDto
     */
    orderId?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof BoxGoodsDto
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof BoxGoodsDto
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the BoxGoodsDto interface.
 */
export function instanceOfBoxGoodsDto(value: object): value is BoxGoodsDto {
    return true;
}

export function BoxGoodsDtoFromJSON(json: any): BoxGoodsDto {
    return BoxGoodsDtoFromJSONTyped(json, false);
}

export function BoxGoodsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoxGoodsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'boxId': json['boxId'] == null ? undefined : json['boxId'],
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'freezeQuantity': json['freezeQuantity'] == null ? undefined : json['freezeQuantity'],
        'availableQuantity': json['availableQuantity'] == null ? undefined : json['availableQuantity'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'deleteStatus': json['deleteStatus'] == null ? undefined : json['deleteStatus'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function BoxGoodsDtoToJSON(json: any): BoxGoodsDto {
    return BoxGoodsDtoToJSONTyped(json, false);
}

export function BoxGoodsDtoToJSONTyped(value?: BoxGoodsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'boxId': value['boxId'],
        'goodsId': value['goodsId'],
        'skuId': value['skuId'],
        'quantity': value['quantity'],
        'freezeQuantity': value['freezeQuantity'],
        'availableQuantity': value['availableQuantity'],
        'enable': value['enable'],
        'deleteStatus': value['deleteStatus'],
        'orderId': value['orderId'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

